export const customTableStyles = {
    rows: {
        style: {
            minHeight: '100px', // override the row height
        }
    },
    headCells: {
        style: {
            fontSize: '14px',
            background: '#696cff29',
            color: '#566a7f'
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            color: '#697a8d',
            lineHeight: '22px'
        },
    },
};


export const customTableStylesForSummery = {
    rows: {
        style: {
            minHeight: '50px', // override the row height
        }
    },
    headCells: {
        style: {
            fontSize: '14px',
            background: '#696cff29',
            color: '#566a7f',
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            color: '#697a8d',
            lineHeight: '22px',
            textAlign:'center'
        },
    },
};

